import { GroupChannelProvider } from '@sendbird/uikit-react/GroupChannel/context';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectChannelUrl } from '_store/chat/selector';

import CustomGroupChannelView from './CustomGroupChannelView';

const CustomGroupChannel = () => {
  const channelUrl = useSelector(selectChannelUrl);

  return (
    <GroupChannelProvider channelUrl={channelUrl}>
      <CustomGroupChannelView />
    </GroupChannelProvider>
  );
};

export default CustomGroupChannel;
